const colorMap = {
  "Blue": "#0000ff",
  "Sky": "#87cfeb",
  "White": "#ffffff",
  "Red": "#ff0000",
  "Others": "#808080",
  "Pink": "#ffc0cb",
  "Black": "#000000",
  "Navy": "#000080",
  "Green": "#00ff00",
  "Cream": "#fffdd0",
  "Beige": "#f5f5dc",
  "Brown": "#964b00",
  "Yellow": "#ffff00",
  "Lilac": "#c8a2c8",
  "Maroon": "#800000",
  "Orange": "#ffa600",
  "Light Grey": "#d3d3d3",
  "Olive": "#808000",
  "Purple": "#a020f0",
  "Dark Grey": "#a9a9a9",
  "Sand": "#c2b180",
  "Black & White": "#000000",
  "Rust": "#b7410e",
  "Gold": "#ffd900",
  "Golden": "#FFD700",
  "Ochre": "#cc7722",
  "Teal": "#008080",
  "Grey": "#808080",
  "Ink": "#27221f",
  "Lime": "#00ff00",
  "Turquoise": "#40e0d0",
  "Anthra": "#353c40",
  "Aqua": "#00ffff",
  "Mustard": "#ffdb58",
  "Sea Green": "#2e8b56",
  "Burgundy": "#800020",
  "Cobalt": "#0047ab",
  "Mint": "#3eb489",
  "Chocolate": "#7b4000",
  "Coral": "#ff7f50",
  "Dark Pink": "#aa336a",
  "Dark Red": "#8b0000",
  "Ecru": "#c2b180",
  "Khaki": "#f0e68c",
  "Dark Blue": "#00008b",
  "Dark Maroon": "#3c0008",
  "Medium Grey": "#a9a9a9",
  "Rose": "#ff0080",
  "Stone": "#ada587",
  "Camel": "#c19a6b",
  "Charcoal": "#36454f",
  "Medium Red": "#8b0000",
  "Peach": "#ffe5b4",
  "Royal": "#4169e1",
  "Tangerine": "#f28500",
  "Aubergine": "#614051",
  "Dark Brown": "#654321",
  "Dark Gold": "#ffd900",
  "Dark Green": "#013220",
  "Dark Olive": "#556b2f",
  "Jade": "#00a86a",
  "Light Blue": "#add8e6",
  "Light Brown": "#c4a484",
  "Medium Blue": "#0000cd",
  "Medium Brown": "#7f5212",
  "Silver": "#c0c0c0",
  "Tan": "#d2b48c",
  "Wine": "#722f37"
};

// const colorMap = {
//   "BLACK": "#000000",
//   "BLUE": "#0000FF",
//   "GREY": "#808080",
//   "WHITE": "#FFFFFF",
//   "BROWN": "#964B00",
//   "GREEN": "#00FF00",
//   "TAN": "#D2B48C",
//   "RED": "#FF0000",
//   "ORANGE": "#FFA600",
//   "BLACK & BROWN": "#4A2C20",
//   "BLACK & WHITE": "#000000",
//   "PINK": "#FFC0CB",
//   "WHITE & GREEN": "#FFFFFF",
//   "MAROON": "#800000",
//   "YELLOW": "#FFFF00",
//   "BLUE & WHITE": "#0000FF",
//   "BEIGE": "#F5F5DC",
//   "RED & WHITE": "#FF0000",
//   "BLUE & PINK": "#0000FF",
//   "BLACK & BLUE": "#000000",
//   "WHITE & GREY": "#FFFFFF",
//   "WHITE & YELLOW": "#FFFFFF",
//   "ORANGE & CREAM": "#FFA600",
//   "PURPLE": "#A020F0",
//   "SILVER": "#C0C0C0",
//   "WHITE & BEIGE": "#FFFFFF",
//   "WHITE & PINK": "#FFFFFF",
//   "YELLOW & BLUE": "#FFFF00",
//   "BLACK & GREEN": "#000000",
//   "BLACK & ORANGE": "#000000",
//   "WHITE & PURPLE": "#FFFFFF",
//   "CREAM": "#FFFDD0",
//   "DESERT SAND": "#C2B280",
//   "PEACH": "#FFE5B4",
//   "BLUE & BROWN": "#0000FF",
//   "BROWN & GREEN": "#964B00",
//   "OFF WHITE": "#FAF9F6",
//   "PINK & YELLOW": "#FFC0CB",
//   "RED & BLACK": "#FF0000",
//   "GLACIER": "#D9F3FF",
//   "GREEN & GREY": "#00FF00",
//   "Gold": "#FFD900",
//   "LEMON POP": "#FFF44F",
//   "MIDNIGHT HUSTLE": "#191970",
//   "MILKY MIST": "#F5F5F5",
//   "NAVY": "#000080",
//   "WHITE & ORANGE": "#FFFFFF",
//   "WHITE:TAN": "#FFFFFF",
//   "ARCTIC WHITE": "#F8FFFF",
//   "ASH MINT": "#B2D8C5"
// };


window.onWizzyScriptLoaded = function () {



    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
        function (payload) {
            window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
            // window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
            //     {
            //         "dom": "#st-search-input-desktop, #st-search-input-mobile, #searchInput",
            //         "type": "text"
            //     }
            // ]
            if(window.document.documentElement.clientWidth <= 768){
              window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
                {
                    "dom": "#st-search-input-mobile, #searchInput",
                    "type": "text"
                }
              ]
            }else {
              window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
                {
                    "dom": "#st-search-input-desktop",
                    "type": "text"
                }
              ]
            }
            window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push("#main")

            initWizzySearch();

            return payload;
        }
    );


  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
      if(window.document.documentElement.clientWidth <= 768){
         window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
          {
              "dom": "#st-search-input-mobile, #searchInput",
              "type": "text"
          }
        ]
      }else {
        window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
          {
              "dom": "#st-search-input-desktop",
              "type": "text"
          }
        ]
      }
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push("#main")

      initWizzySearch();

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
      // console.log(payload, " <== AFTER_PRODUCTS_TRANSFORMED")
      
      payload.forEach(product => {

        if (product.attributes && Array.isArray(product.attributes)) {

          product.attributes.forEach(attr => {

            // Product SKU
            if (
              attr.id === "product_sku" &&
              attr.values?.length
            ) {
              product.productSku = attr.values[0]?.value?.[0] || "";
            }

            // Product Custom Label
            if (
              attr.id === "product_custom_label_custom" &&
              attr.values?.length
            ) {
              product.productCustomLabel =
                attr.values[0]?.value?.[0] || "";
            }

            // Loox Average Rating
            if (
              attr.id === "product_avg_rating_loox" &&
              attr.values?.length
            ) {
              product.avgRatingLoox =
                parseFloat(attr.values[0]?.value?.[0]) || 0;
            }

            // Loox Number of Reviews
            if (
              attr.id === "product_num_reviews_loox" &&
              attr.values?.length
            ) {
              product.numReviewsLoox =
                parseInt(attr.values[0]?.value?.[0], 10) || 0;
            }

            // Product Handle
            if (
              attr.id === "product_handle" &&
              attr.values?.length
            ) {
              product.productHandle =
                attr.values[0]?.value?.[0] || "";
            }

          });

        }

        // First 3 product images
        if (Array.isArray(product.images)) {
          product.productImages = product.images.slice(0, 3);
        } else {
          product.productImages = [];
        }

      });
            
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      // console.log(payload, "BEFORE_AUTOCOMPLETE_EXECUTED");
      // payload.minQueryLength = 1;
      return payload;
    }
  );

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER, function(data) {
      // console.log(data, "<====BEFORE_AUTOCOMPLETE_RENDER");

      function init() {
        document.querySelectorAll('.product-slider').forEach(slider => {
            if (slider.classList.contains('swiper-initialized')) return;

            new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 10,
                loop: true,
                mousewheel: {
                    forceToAxis: true,
                },
                allowTouchMove: true,
                pagination: {
                    el: slider.querySelector('.newpg'),
                    clickable: true,
                }
            });
        });
      }

      // 2️⃣ Initial load
      setTimeout(() => {
        init();
      }, 10);

      return data;
    })

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
      function (payload) {

        // console.log(payload, "BEFORE_AUTOCOMPLETE_RENDER");

        const query = (
          payload?.payload?.products?.filters?.q ||
          ""
        ).toLowerCase().trim();

        // Keywords related to order tracking
        const trackOrderKeywords = [
          "track",
          "tracking",
          "track order",
          "order track",
          "order tracking",
          "track my order",
          "where is my order",
          "order status"
        ];

        const isTrackOrderQuery = trackOrderKeywords.some(keyword =>
          query.includes(keyword)
        );

        if (isTrackOrderQuery) {

          const trackOrderPage = {
            value: "Track Your Order",
            valueHighlighted: "Track Your Order",
            filters: {
              pages: [
                {
                  id: "track-order",
                  title: "Track Your Order",
                  url: "https://baccabucci.clickpost.ai/en",
                  slug: "track-order"
                }
              ]
            },
            payload: []
          };

          // Add the custom page only if it doesn't already exist
          const alreadyExists = payload.payload.pages?.some(
            page => page.filters?.pages?.some(
              p => p.id === "track-order"
            )
          );

          if (!alreadyExists) {
            payload.payload.pages = [
              trackOrderPage,
              ...(payload.payload.pages || [])
            ];
          }
        }

        return payload;
      }
    );

   window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      // console.log(payload,"BEFORE_SEARCH_EXECUTED")

      if (window.innerWidth <= 1024) {
          const closeBtn = document.querySelector(".wizzy-search-form .wizzy-search-back");
          if (closeBtn) {
              closeBtn.click();
          }
      }

      if (
          Array.isArray(payload.sort) &&
          payload.sort.length > 0 &&
          payload.sort[0].field === "relevance" &&
          payload.sort[0].order === "asc"
      ) {
          payload.sort = [
              payload.sort[0], // Keep relevance as first sort
              {
                  "field": "product_wizzy-best-selling_sortOrder:float",
                  "order": "asc"
              }
          ];
      }

      console.log(payload.sort, "UPDATED_SORT");

      return payload;
    }
  );

     window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (payload) {
      // console.log(payload.filters,"BEFORE_FILTERS_EXECUTED");
      
       if (payload.filters.sort) {
            if (
                Array.isArray(payload.filters.sort) &&
                payload.filters.sort.length > 0 &&
                payload.filters.sort[0].field === "relevance" &&
                payload.filters.sort[0].order === "asc"
            ) {
                payload.filters.sort = [
                    payload.filters.sort[0], // Keep relevance as first sort
                    {
                        field: `product_wizzy-best-selling_sortOrder:float`,
                        order: "asc"
                    }
                ];
            }

            // console.log(payload.filters.sort, "UPDATED_SORT");
        }
      
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      // console.log(data," <= VIEW_RENDERED");

      attachApplyFilterHandler();
      attachClearFilterHandler();

      function init() {
        document.querySelectorAll('.product-slider').forEach(slider => {
            if (slider.classList.contains('swiper-initialized')) return;

            new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 10,
                loop: true,
                mousewheel: {
                    forceToAxis: true,
                },
                allowTouchMove: true,
                pagination: {
                    el: slider.querySelector('.newpg'),
                    clickable: true,
                }
            });
        });
    }

      // 2️⃣ Initial load
      init();

      window.wizzyFilterPanel.init();

      
      const total = data?.data?.response?.payload?.total;
      if (total === 1) {
          document.body.classList.add("wizzy-single-result");
      } else {
          document.body.classList.remove("wizzy-single-result");
      }
      
      return data;
    }
  );

   window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      // console.log(payload,"BEFORE_RENDER_RESULTS");

      if (payload.response.payload.facets) {
        payload.response.payload.facets.forEach((facet) => {
          if (facet.key === "product_colors_filters_custom") {
            const ColorData = facet.data;
            if (ColorData) {
              // console.log(ColorData, "color data");
              ColorData.forEach((color) => {
                const colorLabel = color.label?.trim().toUpperCase();
                const swatchValue = colorMap[color.label];

                color.swatchValue = swatchValue;

                if (color.data?.swatch) {
                  color.data.swatch.type = "visual";
                  color.data.swatch.value = swatchValue;
                }

                color.isVisualSwatch = true;
                color.isSwatch = true;
                color.isURLSwatch = false;

                // console.log(color, "UPDATED COLOR");
              });
              facet.data = ColorData;
            }
          }
        });
      }

      // console.log(payload,"BEFORE_RENDER_RESULTS");
    
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (payload) {

      attachApplyFilterHandler();
      attachClearFilterHandler();

      function init() {
        document.querySelectorAll('.product-slider').forEach(slider => {
            if (slider.classList.contains('swiper-initialized')) return;

            new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 10,
                loop: true,
                mousewheel: {
                    forceToAxis: true,
                },
                allowTouchMove: true,
                pagination: {
                    el: slider.querySelector('.newpg'),
                    clickable: true,
                }
            });
        });
    }

      // 2️⃣ Initial load
      init();

      window.wizzyFilterPanel.init();

      
      // const total = data?.data?.response?.payload?.total;
      // if (total === 1) {
      //     document.body.classList.add("wizzy-single-result");
      // } else {
      //     document.body.classList.remove("wizzy-single-result");
      // }

      return payload;
    }
  );

};



///////////////////////////////////////////////

/**
 * Wizzy left filters panel - show / hide
 * Pairs with wizzy-filter-panel.css
 *
 * Click `.wizzy-filters-mobile-entry-desktop` to toggle
 * `.wizzy-search-filters-left`. Hidden to start with, opens from the left over
 * 1.5s, closes the same way. Desktop only.
 *
 * While the panel is open, <body> carries `wizzy-filters-panel-open` - hook any
 * of your own styling onto that class.
 *
 * The animation does NOT use CSS transitions. Wizzy's and the theme's own rules
 * for this element kept cutting them short, so each frame is written here as an
 * inline `!important` style instead - the one thing no stylesheet can override.
 * Opening and closing run the same loop, so both take exactly DURATION.
 *
 * Run `wizzyFilterPanel.init()` as many times as you like - e.g. on every
 * search render. Buttons that are already wired are skipped (they carry a
 * `data-wz-bound` marker), so no event is ever attached twice.
 */
(function () {
  "use strict";

  var BUTTON_SELECTOR = ".wizzy-filters-mobile-entry-desktop";
  var PANEL_SELECTOR = ".wizzy-search-filters-left";
  var BODY_CLASS = "wizzy-filters-panel-open"; // on <body> while the panel is open
  var HIDDEN_CLASS = "wz-filters-hidden"; // display:none, see the CSS
  var READY_CLASS = "wz-filters-ready"; // marks a panel we have taken over

  var WIDTH = 295; // px - the panel's width when open
  var DURATION = 500; // ms - same for opening and closing
  var DESKTOP_QUERY = "(min-width: 769px)";

  var isOpen = false; // survives re-renders of the panel markup
  var frame = null; // running requestAnimationFrame
  var openBox = null; // the panel's natural side margins / padding

  /* ---------------------------------------------------------------- utils */

  function isDesktop() {
    return !window.matchMedia || window.matchMedia(DESKTOP_QUERY).matches;
  }

  function getPanel() {
    return document.querySelector(PANEL_SELECTOR);
  }

  function set(el, prop, value) {
    el.style.setProperty(prop, value, "important");
  }

  function unset(el, prop) {
    el.style.removeProperty(prop);
  }

  /* smooth start, smooth end */
  function ease(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  }

  /* Remember the panel's own spacing once, while it is still untouched, so the
     animation can grow back into exactly those values. */
  function readBox(panel) {
    if (openBox) return openBox;
    var s = window.getComputedStyle(panel);
    openBox = {
      marginLeft: parseFloat(s.marginLeft) || 0,
      marginRight: parseFloat(s.marginRight) || 0,
      paddingLeft: parseFloat(s.paddingLeft) || 0,
      paddingRight: parseFloat(s.paddingRight) || 0,
    };
    return openBox;
  }

  /* Hold the contents at full width so nothing re-wraps while the panel
     narrows - it is just clipped instead. */
  function pinContents(panel, on) {
    var kids = panel.children;
    for (var i = 0; i < kids.length; i++) {
      if (on) set(kids[i], "min-width", WIDTH + "px");
      else unset(kids[i], "min-width");
    }
  }

  /* --------------------------------------------------------- the animation */

  /* progress 0 = fully closed, 1 = fully open */
  function paint(panel, progress) {
    var box = readBox(panel);
    var width = WIDTH * progress;

    set(panel, "width", width + "px");
    set(panel, "min-width", "0px");
    set(panel, "max-width", "none");
    set(panel, "flex-basis", width + "px");
    set(panel, "flex-grow", "0");
    set(panel, "flex-shrink", "0");
    set(panel, "opacity", String(progress));
    set(panel, "margin-left", box.marginLeft * progress + "px");
    set(panel, "margin-right", box.marginRight * progress + "px");
    set(panel, "padding-left", box.paddingLeft * progress + "px");
    set(panel, "padding-right", box.paddingRight * progress + "px");
  }

  function stopFrame() {
    if (frame) {
      cancelAnimationFrame(frame);
      frame = null;
    }
  }

  /* Current progress, so an interrupted animation reverses from where it is. */
  function currentProgress(panel) {
    var width = panel.getBoundingClientRect().width;
    if (!width) return 0;
    return Math.max(0, Math.min(1, width / WIDTH));
  }

  function run(panel, from, to, done) {
    stopFrame();

    var startedAt = null;
    var span = Math.abs(to - from);
    var duration = Math.max(1, DURATION * span); // partial travel takes less time

    function step(now) {
      if (startedAt === null) startedAt = now;

      var t = Math.min((now - startedAt) / duration, 1);
      paint(panel, from + (to - from) * ease(t));

      if (t < 1) {
        frame = requestAnimationFrame(step);
      } else {
        frame = null;
        done();
      }
    }

    frame = requestAnimationFrame(step);
  }

  /* --------------------------------------------------------- open / close */

  function show(panel) {
    isOpen = true;
    document.body.classList.add(BODY_CLASS);

    readBox(panel);
    pinContents(panel, true);
    set(panel, "overflow", "hidden");

    var from = panel.classList.contains(HIDDEN_CLASS) ? 0 : currentProgress(panel);
    panel.classList.remove(HIDDEN_CLASS); // back into the layout
    paint(panel, from);

    run(panel, from, 1, function () {
      /* hand the panel back to the stylesheet, minus the width we own */
      pinContents(panel, false);
      unset(panel, "overflow");
      unset(panel, "opacity");
      unset(panel, "margin-left");
      unset(panel, "margin-right");
      unset(panel, "padding-left");
      unset(panel, "padding-right");
      set(panel, "width", WIDTH + "px");
      set(panel, "flex-basis", WIDTH + "px");
    });
  }

  function hide(panel) {
    isOpen = false;
    document.body.classList.remove(BODY_CLASS);

    readBox(panel);
    pinContents(panel, true);
    set(panel, "overflow", "hidden");

    run(panel, currentProgress(panel), 0, function () {
      paint(panel, 0);
      panel.classList.add(HIDDEN_CLASS); // already at zero width by now
      pinContents(panel, false);
    });
  }

  function toggle() {
    var panel = getPanel();
    if (!panel || !isDesktop()) return;
    if (isOpen) hide(panel);
    else show(panel);
  }

  function onClick(e) {
    e.preventDefault();
    toggle();
  }

  /* ----------------------------------------------------------------- init */

  /* Safe to run over and over - only new buttons get a listener. */
  function init() {
    document.body.classList.toggle(BODY_CLASS, isOpen); // keep <body> in sync

    var panel = getPanel();
    if (panel && isDesktop() && !panel.classList.contains(READY_CLASS)) {
      panel.classList.add(READY_CLASS);
      readBox(panel); // capture the natural spacing before we touch anything

      if (isOpen) {
        paint(panel, 1);
      } else {
        paint(panel, 0);
        set(panel, "overflow", "hidden");
        panel.classList.add(HIDDEN_CLASS);
      }
    }

    var buttons = document.querySelectorAll(BUTTON_SELECTOR);
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].getAttribute("data-wz-bound")) continue;
      buttons[i].setAttribute("data-wz-bound", "1");
      buttons[i].addEventListener("click", onClick);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.wizzyFilterPanel = {
    init: init,
    toggle: toggle,
    show: function () {
      var panel = getPanel();
      if (panel) show(panel);
    },
    hide: function () {
      var panel = getPanel();
      if (panel) hide(panel);
    },
  };
})();


/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


/*
  Keeps the mobile autocomplete just below whichever search input is in use.
  Mobile has two: the header bar (.st-search-bar) and the drawer (#search_mini_form);
  both share id #st-search-input-mobile, so we track the last focused one.
*/
var wizzyActiveMobileSearchInput = null;
var WIZZY_MOBILE_AC_GAP = 8;

document.addEventListener("focusin", function (e) {
  if (e.target.matches && e.target.matches("#st-search-input-mobile, #searchInput")) {
    wizzyActiveMobileSearchInput = e.target;
    updateMobileAutocompleteTop();
  }
});

function updateMobileAutocompleteTop() {
  var bottom;
  if (document.body.classList.contains("wizzyMobileTappedNew")) {
    // drawer: the fixed form already includes its own bottom padding
    var form = document.querySelector(".wizzy-search-form-wrapper .wizzy-search-form");
    if (!form) return;
    bottom = form.getBoundingClientRect().bottom;
  } else {
    var input = wizzyActiveMobileSearchInput;
    if (!input || !input.isConnected || input.closest("#search_mini_form")) {
      input = document.querySelector(".st-search-bar #st-search-input-mobile");
    }
    if (!input) return;
    bottom = input.getBoundingClientRect().bottom + WIZZY_MOBILE_AC_GAP;
  }
  bottom = Math.max(0, Math.ceil(bottom));
  if (bottom > 0) {
    document.body.style.setProperty("--wizzy-mobile-ac-top", bottom + "px");
  }
}
window.addEventListener("resize", updateMobileAutocompleteTop);
window.addEventListener("scroll", function () {
  if (document.body.classList.contains("wizzy-autocomplete-open")) updateMobileAutocompleteTop();
}, { passive: true });

/* Mobile search popup - opens on .st-icon-search, closes on .wizzy-search-back */
document.addEventListener("click", function (e) {
  var wrapper = document.querySelector(".wizzy-search-form-wrapper");
  if (!wrapper) return;

  if (e.target.closest(".st-icon-search")) {
    e.preventDefault();
    document.body.classList.add("wizzyMobileTappedNew");
    wrapper.classList.add("mobileTapped");
    // next frame, so the slide-in has an off-screen state to animate from
    requestAnimationFrame(function () {
      wrapper.classList.add("wizzy-search-drawer-open");
      updateMobileAutocompleteTop();
    });
    setTimeout(() => {
      
      document.querySelector("#st-search-input-mobile").focus();
      document.querySelector("#st-search-input-mobile").click();
    }, 500);
  }

  if (e.target.closest(".wizzy-search-back")) {
    e.preventDefault();
    wrapper.classList.remove("wizzy-search-drawer-open");
    setTimeout(function () {
      wrapper.classList.remove("mobileTapped");
      document.body.classList.remove("wizzyMobileTappedNew");
    }, 350); // matches the CSS transition
  }
});



/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



function attachClearFilterHandler() {
  document
    .querySelectorAll(".wizzy-search-filters-left .active-facets__button-remove")
    .forEach((button) => {
      if (button.classList.contains("wizzy-clear-handler-attached")) {
        return;
      }

      button.classList.add("wizzy-clear-handler-attached");

      button.addEventListener("click", () => {
        const clearAllButton = document.querySelector(
          ".wizzy-filters-clear-all"
        );

        if (clearAllButton) {
          clearAllButton.click();
        }
      });
    });
}

attachClearFilterHandler();



function attachApplyFilterHandler() {
  const applyButton = document.querySelector(
    ".facets__button.facets__submit"
  );

  if (
    !applyButton ||
    applyButton.classList.contains("wizzy-apply-handler-attached")
  ) {
    return;
  }

  applyButton.classList.add("wizzy-apply-handler-attached");

  applyButton.addEventListener("click", () => {

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant"
    });

    window.location.reload();
  });
}

const targetNode = document.querySelector(".wizzy-body-end-wrapper");
    function updateBodyClass() {
      const autocompleteElement = targetNode.querySelector(".wizzy-autocomplete-wrapper");
      autocompleteElement && window.getComputedStyle(autocompleteElement).display === "flex" ? document.body.classList.add("wizzy-autocomplete-open") : document.body.classList.remove("wizzy-autocomplete-open")
      updateMobileAutocompleteTop();
    }
    const config = {
      childList: !0,
      subtree: !0,
      attributes: !0,
      attributeFilter: ["style"]
    }
      , callback = function (mutationsList, observer2) {
        for (const mutation of mutationsList) {
          updateBodyClass();
          break
        }
      }
    ,observer = new MutationObserver(callback);
    targetNode && (observer.observe(targetNode, config),
    updateBodyClass());
attachApplyFilterHandler();



////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

function initWizzySearch() {
  setTimeout(function () {
    const forms = document.querySelectorAll(".search-modal__form");

    forms.forEach(function (form) {
      const input = form.querySelector(".wizzy-search-input");
      const button = form.querySelector(".side-btn");

      if (!input || !button) return;

      // Prevent duplicate event listeners
      if (form.dataset.wizzySearchInitialized === "true") {
        return;
      }

      form.dataset.wizzySearchInitialized = "true";

      function executeSearch() {
        const query = input.value.trim();

        if (!query) return;

        const url = new URL("/pages/search", window.location.origin);
        url.searchParams.set("q", query);

        // Actually navigate/reload the search page
        window.location.href = url.toString();
      }

      // Search icon
      button.addEventListener("click", function (e) {
        e.preventDefault();
        executeSearch();
      });

      // Enter key
      // form.addEventListener("submit", function (e) {
      //   e.preventDefault();
      //   executeSearch();
      // });
    });
  }, 500);
}

